<template>
    <div id="container" type="vmortgagecalculator">
        <div class="page page-mortgagecalculator" v-ga:request="{pageType:'vmortgagecalculator', state: {}}" v-ga:page="{pageType:'vmortgagecalculator', glb: glb, state: {}}">
            <mvtHeader />
            <section class="inline large">
                <div class="fixed fixed-max-sm gap-3 grid xs-grid-cols-1">
                    <div class="text-center">
                        <h1><b class="f0 text-bold">Mortgage Calculator</b></h1>
                    </div>
                    <div class="mortgage-calculator-section flex wrap large fixed fixed-max-sm top stretch">
                        <div class="flex-xs-12 flex-sm-12 flex-md-8 flex-lg-8">
                            <div class="combined-form flex inline bg-default corner">
                                <div class="mortgage-calculator-form">
                                    <form class="grid xs-grid-cols-1 form" novalidate>
                                        <div class="input">
                                            <label>ZIP Code</label>
                                            <input
                                                type="text"
                                                placeholder="ZIP Code"
                                                v-model.lazy="zipcode"
                                                v-validate="'required|zipcode'"
                                                maxlength="5"
                                                @input="getCurrentZipMortgage"
                                                v-valueChange="zipcode"
                                            />
                                        </div>
                                        <div class="merge">
                                            <div class="input">
                                                <label>Down Payment</label>
                                                <mvtInputNumber v-model="downPayment" placeholder="Down Payment" @change="updataPercentageDown" maxlength="20" :prefix="'$'" />
                                            </div>
                                            <div class="input">
                                                <label>Percent Down</label>
                                                <mvtInputDecimalNumber v-model="percentDown" placeholder="Percent" @change="updataDownpayment" :suffix="'%'" />
                                            </div>
                                        </div>
                                        <div class="input">
                                            <label>Home Price</label>
                                            <mvtInputNumber v-model="homePrice" placeholder="Home Price" @input="mortgageCalculations" maxlength="20" :prefix="'$'" />
                                        </div>
                                        <div class="input">
                                            <label>Interest Rate</label>
                                            <mvtInputDecimalNumber v-model="interestRate" placeholder="Interest Rate" @change="mortgageCalculations" :suffix="'%'" />
                                        </div>
                                        <div class="input">
                                            <label>Loan Type</label>
                                            <mvtSelect :data="interestRateList" v-model="loanType" placeholder="Loan Type" @change="updateInterstRate" />
                                        </div>
                                        <div class="grid xs-grid-cols-1" v-if="showExtraFields">
                                            <div class="input">
                                                <label>Credit Score</label>
                                                <mvtSelect :data="creditList" v-model="credit" />
                                            </div>
                                            <div class="merge">
                                                <div class="input">
                                                    <label>Property Tax Est.</label>
                                                    <mvtInputNumber v-model="propertyTax" @input="mortgageCalculations" :prefix="'$'" />
                                                </div>
                                                <div class="input">
                                                    <label>Percent</label>
                                                    <mvtInputDecimalNumber v-model="propertyTaxRate" @input="updataTaxRate" :suffix="'%'" />
                                                </div>
                                            </div>
                                            <div class="input">
                                                <label>Yearly Home Insurance</label>
                                                <mvtInputNumber v-model="homeInsurance" @input="mortgageCalculations" :prefix="'$'" />
                                            </div>
                                            <div class="input">
                                                <label>Montly HOA Fee</label>
                                                <mvtInputNumber v-model="hoafee" @input="mortgageCalculations" :prefix="'$'" />
                                            </div>
                                        </div>
                                        <div class="group">
                                            <a @click="() => { showExtraFields = !showExtraFields }" href="javascript:void(0)" class="link">
                                                {{ `Show ${showExtraFields ? 'fewer' : 'more'} options` }}
                                            </a>
                                        </div>
                                    </form>
                                </div>

                                <div class="mortgage-info">
                                    <div class="monthly-payment-label">Total Monthly Payment</div>
                                    <div class="monthly-payment-value">
                                        <span class="text-bold">{{ $filters.formatPrice(pricePerMonth) }}</span>
                                    </div>
                                    <div class="process-bar">
                                        <div v-for="item in chartData" :style="{ width: item.value}" :type="item.key"></div>
                                    </div>
                                    <div class="info">
                                        <div v-for="item in chartData">
                                            <label :type="item.key"></label>
                                            <div v-if="item.key==='Interest'">Principal & Interest</div>
                                            <div v-else-if="item.key==='Taxes'">Property Taxes</div>
                                            <div v-else-if="item.key==='HOA'">Monthly HOA Fee</div>
                                            <div v-else-if="item.key==='PMI'">Mortgage Insurance</div>
                                            <div v-else-if="item.key==='Insurance'">Insurance</div>
                                            <b>{{ $filters.formatPrice(item.price) }}</b>
                                        </div>
                                        <hr />
                                        <div>
                                            <div>Total Monthly Payment</div>
                                            <b>{{ $filters.formatPrice(monthTotal) }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-xs-12 flex-sm-12 flex-md-4 flex-lg-4">
                            <div class="pre-approved inline corner wrap center">
                                <h2 class="f3 text-bold">Next Step: <br />Get Preapproved</h2>
                                <div class="info">Most agents require a preapproval letter to tour homes in person.</div>
                                <div class="pre-approved-nav">
                                    <div class="input">
                                        <input
                                            v-model.lazy="zipcode"
                                            ref="zipcode"
                                            name="zipcode"
                                            v-validate="'required|zipcode'"
                                            type="text"
                                            placeholder="ZIP Code"
                                            maxlength="5"
                                            v-valueChange="zipcode"
                                        />
                                    </div>
                                    <button class="btn primary regular" @click="preApprovalPage($event)">Get Started</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="inline large">
                <mvtLazyload>
                    <mvtRateTrend></mvtRateTrend>
                </mvtLazyload>
            </section>

            <mortgageTools :id="glb.pageType" preTitle="EXPERT GUIDANCE AND RESOURCES" title="Tools for every step of your real estate journey"></mortgageTools>

            <section class="inline large">
                <div class="fixed fixed-max-sm grid xs-grid-cols-1">
                    <div class="text-center">
                        <h2>
                            <b class="f3 text-bold">Frequently Asked Questions</b>
                        </h2>
                    </div>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <section class="inline large" v-if="tag">
                <div class="fixed fixed-max-sm grid xs-grid-cols-1 gap-3">
                    <div class="text-center">
                        <h2 class="f3 text-bold">Related Articles</h2>
                    </div>
                    <mvtArticle :tag="tag" />
                </div>
            </section>

            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-mortgagecalculator.js"></script>

<style lang="scss">
    @use './page-mortgagecalculator.scss' as *;
</style>
